import { compose, renameProp, setDisplayName } from 'recompose';

import FormMultilineTextField from 'components/FormMultilineTextField';
import StylingToCSSTextfield from 'styling/hocs/StylingToCSS/StylingToCSSTextfield';

const FormMultilineTextFieldWithStyle = compose(
  StylingToCSSTextfield,
  setDisplayName('FormMultilineTextFieldWithStyle'),
  renameProp('styleTextfield', 'style'),
)(FormMultilineTextField);

export default FormMultilineTextFieldWithStyle;
